<template>
  <div>
    <ModifyVisit v-if="isModifyVisit" />
    <AppointmentsCalendar v-else />
  </div>
</template>

<script>
import AppointmentsCalendar from "./components/AppointmentsCalendar.vue";
import ModifyVisit from "./components/ModifyVisit.vue";

export default {
  name: "App",

  components: {
    AppointmentsCalendar,
    ModifyVisit
  },

  computed: {
    isModifyVisit() {
      return window.location.pathname === "/modifyVisit";
    }
  }
};
</script>

<style>
body {
  overflow-y: scroll;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>